export default __webpack_public_path__ + "static/media/logo-css-3-1024.d9b4581c.png";